import { sendToApi } from 'api/client'

import { ChannelMember } from 'types'

export enum ChannelMembershipOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export const ChannelMembershipClient = {
  update: async (id: number, params: { owner?: boolean; position?: number }) => {
    return sendToApi<{ channel_memberships: ChannelMember[] }>(`/channel_memberships/${id}`, {
      method: 'PUT',
      body: { channel_membership: params },
    })
  },

  delete: async (id: number) => {
    return sendToApi(`/channel_memberships/${id}`, { method: 'DELETE' })
  },
}
